import { type JSX } from 'react';
import { useIntl } from 'react-intl';

import { screenReaderOnly } from '../../../../styles/screen-reader-only.sty.js';
import { useDataTable } from '../../contexts/DataTableContext.js';
import { dataTableMessages } from '../../messages.js';

/**
 * Announces the current selection count via a polite live region whenever it
 * changes.
 * @internal
 */
export function RowSelectionAnnouncement(): JSX.Element {
  const table = useDataTable();
  const intl = useIntl();
  const selectionCount = table.getSelectionCount();

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className={screenReaderOnly}
    >
      {intl.formatMessage(dataTableMessages.rowSelectionAnnouncement, {
        count: selectionCount,
      })}
    </div>
  );
}
